import type { SpaceTheme } from './light'
import commonVars from './_common'

const spaceDark: SpaceTheme = {
  name: 'Space',
  self() {
    return commonVars
  }
}

export default spaceDark
